/**
 * SEO Schema Builders for Cloud4Partners
 * Reusable Schema.org JSON-LD objects — consumed by the SEO component.
 * All schemas exclude price/priceSpecification per site policy.
 */

const BASE_URL = 'https://www.myc4p.com';
const ORG_ID = `${BASE_URL}/#organization`;
const SITE_ID = `${BASE_URL}/#website`;

/** WebSite schema — homepage only */
export const websiteSchema = () => ({
  '@type': 'WebSite',
  '@id': SITE_ID,
  url: BASE_URL,
  name: 'Cloud4Partners',
  description:
    'The complete SAP Business One partner platform. Bundled, standardised, and built on the latest AWS technology.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${BASE_URL}/blog-news?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
});

/**
 * Service schema — product pages.
 * NO price or priceSpecification anywhere.
 */
export const serviceSchema = ({ name, description, url }) => ({
  '@type': 'Service',
  serviceType: 'SAP Business One Cloud Hosting',
  name,
  description,
  url: `${BASE_URL}${url}`,
  provider: {
    '@type': 'Organization',
    '@id': ORG_ID,
  },
  areaServed: {
    '@type': 'Place',
    name: 'Worldwide',
  },
});

/**
 * FAQPage schema — any page with an accordion FAQ section.
 * @param {Array<{q: string, a: string}>} faqs
 */
export const faqPageSchema = (faqs) => ({
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: a,
    },
  })),
});

/**
 * Review schemas for testimonials page.
 * @param {Object} testimonialsObj — the testimonials map from data/testimonials.js
 */
export const reviewSchemas = (testimonialsObj) =>
  Object.values(testimonialsObj).map((t) => ({
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: t.author_name,
      ...(t.author_role && { jobTitle: t.author_role }),
      worksFor: {
        '@type': 'Organization',
        name: t.author_company,
      },
    },
    reviewBody: t.quote,
    itemReviewed: {
      '@type': 'Organization',
      '@id': ORG_ID,
    },
  }));
